var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 2, x: 1, width: 24 },
      ]}},[_c('fetch-story',{attrs:{"route":_vm.cms.api_endpoint || 'en-gb/our-work',"params":{
          sort_by: _vm.cms.api_order || null,
          by_uuids: _vm.cms.api_filter || null,
        },"limit":parseInt(_vm.cms.api_limit) || 0,"offset":parseInt(_vm.cms.api_offset) || 0,"collection":_vm.cms.collection,"entry":"content"},scopedSlots:_vm._u([{key:"default",fn:function({ collection }){return ((collection || []).length > 0)?_c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[`${_vm.name}__thumbnails`]},_vm._l((_vm.setThumbnail(collection)),function(item,index){return _c('div',{key:index},[_c('m-card-wide',{class:[`${_vm.name}__thumbnail`],attrs:{"cms":{
                ...item,
                cta: item.cta.length ? item.cta : _vm.setCta(),
              },"tag-list":item.tags,"url":item.url}})],1)}),0):_vm._e()}}],null,true)})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }